export const ErrorMessage = ({ error }) => {
  return (
    error && (
      <div className="col-md-12">
        <div className="text-center alert alert-danger">{error}</div>
      </div>
    )
  );
};
